import { Box, IconButton, useTheme } from '@mui/material';
import { useContext } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { NavItem } from './NavItem';
import { DrawerContext, DrawerValues } from '../contexts/DrawerContext';

export const SlidingSubMenu = () => {
  const { handleNavItemClick, isMobile, selectedNavItem, slidingSubMenuWidth, setSelectedNavItem } = useContext(DrawerContext) as DrawerValues;
  const theme = useTheme();
  if (isMobile) return <></>;
  if (!selectedNavItem?.children) return <></>;

  return <Box className='AppSlidingSubMenu-root'
    width={slidingSubMenuWidth}
    sx={{
      display: 'flex',
      flexDirection: 'column',
      height: '100vh',
      position: 'relative',
    }}>
    {/* Header with close button */}
    <Box 
      sx={{
        position: 'relative',
        flexShrink: 0,
        paddingTop: '48px',
        paddingLeft: '12px',
        paddingRight: '12px',
        height: '48px',
      }}>
      <IconButton onClick={() => setSelectedNavItem(undefined)}
        style={{ position: 'absolute', right: 0, top: 0, color: theme.palette.primary[300] }}>
        <CloseIcon />
      </IconButton>
    </Box>
    
    {/* Scrollable content area */}
    <Box
      sx={{
        flexGrow: 1,
        flexShrink: 1,
        overflow: 'auto',
        paddingLeft: '12px',
        paddingRight: '12px',
        paddingTop: '12px',
        paddingBottom: '24px',
        scrollBehavior: 'smooth',
        scrollbarWidth: 'thin',
        scrollbarColor: 'rgba(0, 0, 0, 0.2) transparent',
        '&::-webkit-scrollbar': {
          width: '6px',
        },
        '&::-webkit-scrollbar-track': {
          background: 'transparent',
        },
        '&::-webkit-scrollbar-thumb': {
          background: 'rgba(0, 0, 0, 0.2)',
          borderRadius: '3px',
        },
        '&::-webkit-scrollbar-thumb:hover': {
          background: 'rgba(0, 0, 0, 0.3)',
        },
      }}>
      {selectedNavItem.children?.map((each, i) => {
        return <Box key={`SlidingSubMenu-${each.translationKey}-${i}`}
          sx={{ marginBottom: '4px' }}>
          <NavItem item={each}
            onClick={() => handleNavItemClick(each)} />
        </Box>;
      })}
    </Box>
  </Box>;
};